import { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useGetGoogleResultHistoryQuery } from '@/app/KeywordTracker/api/keywordsApi';
import { googleResultsHistoryColumnConfig } from '@/app/KeywordTracker/config/googleResultsHistoryColumnConfig';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import useDomain from '@/hooks/useDomain';

const GoogleResultHistoryDrawer = () => {
  const { domain_slug } = useDomain();
  const { key, payload } = useSelector(state => state.drawer);
  const { keyword_id, keyword } = payload ?? '';
  const { data, isFetching } = useGetGoogleResultHistoryQuery(
    { keyword_id, limit: 30, offset: 0, domain_slug },
    { skip: !keyword_id || key !== 'google_result_history' }
  );
  const gridRef = useRef(null);
  return (
    <DrawerWrapper
      show={key === 'google_result_history'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0">
            سابقه نتایج گوگل در کلمه (
            <strong>{keyword ? decodeURIComponent(keyword) : ''}</strong>)
          </h6>
        </div>
      }
    >
      <Row className="mt-2 g-2">
        <Col>
          {!isFetching ? (
            <div ref={gridRef}>
              <AgGridWrapper
                settings={{
                  pagination: false,
                  fullscreen: false,
                  changeHeight: false,
                  resetGrid: false,
                  saveGrid: false
                }}
                columns={googleResultsHistoryColumnConfig(data?.data?.columns)}
                data={data?.data?.rows}
                height="700px"
              />
            </div>
          ) : (
            <AgGridSkeleton
              height="650px"
              settings={{
                pagination: false,
                fullscreen: false,
                changeHeight: false,
                resetGrid: false,
                saveGrid: false,
                exportBtn: false
              }}
            />
          )}
        </Col>
      </Row>
    </DrawerWrapper>
  );
};

export default GoogleResultHistoryDrawer;
